import queryString from 'query-string';
export var checkUrlSelection = function (href) {
    var url = queryString.parseUrl(href).url;
    return decodeURIComponent(url) === decodeURIComponent(location.pathname);
};
